import { VStack } from '@chakra-ui/react';

import { Message } from '@/features/messages/messages.types';
import { RefObject } from 'react';

import { MessageAttachmentAudio } from './conversation-message-attachment-audio';
import { MessageAttachmentVideo } from './conversation-message-attachments-video';
import { MessageAttachmentFile } from './conversation-message-attachments-file';
import { MessageAttachmentImage } from './conversation-message-attachments-image';

export const MessageAttachments = ({
  isUser,
  isAIAgent,
  messageStatus,
  handleImageClick,
  handleDownloadImage,
  message,
  toggleAudio,
  isPlaying,
  progress,
  audioRefs,
  formatDuration,
}: {
  isUser: boolean;
  isAIAgent: boolean;
  messageStatus: string;
  handleImageClick: (imageUrl: string) => void;
  handleDownloadImage: (imageUrl: string, imageName?: string) => void;
  message: Message;
  toggleAudio: (audioId: string, audioUrl: string) => void;
  isPlaying: { [key: string]: boolean };
  progress: { [key: string]: number };
  audioRefs: RefObject<{ [key: string]: HTMLAudioElement | null }>;
  formatDuration: (seconds: number) => string;
}) => {
  if (!message.attachments || message.attachments.length === 0) {
    return null;
  }

  return (
    <VStack
      gap={2}
      align="stretch"
      mt={message.content ? 2 : 0}
      justify={isUser ? 'flex-start' : 'flex-end'}
    >
      {message.attachments.map((attachment, index) => {
        const attachmentId = `${message.id}-${index}`;

        if (attachment.file_type === 'image') {
          // TODO: Move this to a separate component
          return (
            <MessageAttachmentImage
              key={attachmentId}
              attachment={attachment}
              isUser={isUser}
              isAIAgent={isAIAgent}
              messageStatus={messageStatus}
              handleImageClick={handleImageClick}
              handleDownloadImage={handleDownloadImage}
            />
          );
        } else if (attachment.file_type === 'audio') {
          // TODO: Move this to a separate component
          return (
            <MessageAttachmentAudio
              key={attachmentId}
              attachmentId={attachmentId}
              attachment={attachment}
              isUser={isUser}
              isAIAgent={isAIAgent}
              messageStatus={messageStatus}
              toggleAudio={toggleAudio}
              isPlaying={isPlaying}
              progress={progress}
              audioRefs={audioRefs}
              formatDuration={formatDuration}
              transcription={message.content}
            />
          );
        } else if (
          attachment.file_type === 'video' ||
          attachment.file_url?.toLowerCase().endsWith('.mp4') ||
          (attachment as { mimetype?: string }).mimetype?.startsWith('video/')
        ) {
          // TODO: Move this to a separate component
          return (
            <MessageAttachmentVideo
              key={attachmentId}
              attachment={attachment}
              isUser={isUser}
              isAIAgent={isAIAgent}
              messageStatus={messageStatus}
            />
          );
        } else if (
          attachment.file_type === 'file' ||
          attachment.file_type === 'document' ||
          attachment.file_type === 'pdf' ||
          attachment.file_type === 'docx'
        ) {
          // TODO: Move this to a separate component
          return (
            <MessageAttachmentFile
              key={attachmentId}
              attachment={attachment}
              isUser={isUser}
              isAIAgent={isAIAgent}
              messageStatus={messageStatus}
            />
          );
        }

        return null;
      })}
    </VStack>
  );
};
